import React from 'react';

const SubHeader = () => {

    return(
        <div className="outerdivsubheader">
            <div className="row">
                <div className="col-12">
                    <h2 className='welcome mb-0'>Business Account Opening<br/>SME Banking</h2>
                </div>
            </div>
        </div>
        

    )
}
export default SubHeader;